import React from 'react';
import Spacing from '../../Spacing';
import IconBoxStyle1 from '../../IconBox/IconBoxStyle1';
import MednaBrand from '../../../config/MednaBrand';

const primary = MednaBrand.colors.primary;
const accent = MednaBrand.colors.accent;
const primaryRgba = (a) => `rgba(101, 80, 201, ${a})`;

export default function AwardSection({ sectionTitle, data, bgUrl }) {
  return (
    <div style={{
      padding: '80px 0',
      margin: '20px 0'
    }}>
      {/* Content */}
      <div className="container">
        <div style={{ textAlign: 'center', marginBottom: '20px' }}>
          <h2 style={{
            fontSize: '48px',
            fontWeight: '700',
            color: primary,
            margin: 0,
            fontFamily: '"Latin Modern Math", "STIX Math", "Cambria Math", "Computer Modern", serif',
            fontStyle: 'italic',
            letterSpacing: '-0.5px',
            lineHeight: '1.2'
          }}>
            {sectionTitle}
          </h2>
        </div>
        <Spacing md="30" lg="25" />
        <div className="row gy-4">
          {data?.map((item, index) => (
            <div className="col-xxl-3 col-md-6" key={index}>
              <div style={{
                backgroundColor: '#ffffff',
                borderRadius: '12px',
                padding: '30px',
                height: '100%',
                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
                transition: 'all 0.3s ease',
                border: `1px solid ${primaryRgba(0.2)}`
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-5px)';
                e.currentTarget.style.boxShadow = `0 8px 30px ${primaryRgba(0.2)}`;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 20px rgba(0, 0, 0, 0.1)';
              }}
              >
                <div style={{
                  backgroundColor: 'rgba(101, 80, 201, 0.08)',
                  color: accent,
                  padding: '15px 20px',
                  borderRadius: '8px',
                  marginBottom: '25px',
                  textAlign: 'center',
                  boxShadow: `0 3px 10px ${primaryRgba(0.15)}`,
                  border: '2px solid rgba(101, 80, 201, 0.2)'
                }}>
                  <h2 style={{
                    margin: 0,
                    fontSize: '18px',
                    fontWeight: '700',
                    color: accent,
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px'
                  }}>
                    {item.title.replace('*', '').trim()}
                  </h2>
                </div>
                <div style={{ 
                  paddingTop: '10px',
                  minHeight: '120px'
                }}>
                  <p style={{
                    margin: 0,
                    fontSize: '15px',
                    lineHeight: '1.6',
                    color: '#555',
                    textAlign: 'left'
                  }}>
                    {item.subTitle}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
